import React from 'react';
import { Box, Typography, Avatar, keyframes } from '@mui/material';

// Shake animation keyframes
const shakeAnimation = keyframes`
  0% { transform: rotate(0deg); }
  10% { transform: rotate(-10deg); }
  20% { transform: rotate(10deg); }
  30% { transform: rotate(-10deg); }
  40% { transform: rotate(10deg); }
  50% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
`;

// Wave animation keyframes
const waveAnimation = keyframes`
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(-15deg); }
  75% { transform: rotate(15deg); }
`;

const WelcomeMessage = ({ userName = "Guest" }) => {

    const formatName = (name) => {
        return name
            .toLowerCase() // normalize to lowercase
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    // Get current time for time-based greeting - using local time
    const getCurrentGreeting = () => {
        const now = new Date();
        const hour = now.getHours();
        console.log('Current hour:', hour); // Debug log

        if (hour >= 5 && hour < 12) return "Good Morning";
        if (hour >= 12 && hour < 17) return "Good Afternoon";
        if (hour >= 17 && hour < 22) return "Good Evening";
        return "Good Night";
    };

    // Array of professional motivational messages
    const motivationalMessages = [
        "How can we support your well-being journey?",
        "What would you like to focus on for your wellness today?",
        "Your personalized mental health support awaits.",
        "Let's continue building your path to wellness together.",
        "Ready to take the next step in your wellness journey?",
        "Your mental health matters. How can we assist you today?"
    ];

    // Get random motivational message
    const getRandomMessage = () => {
        const randomIndex = Math.floor(Math.random() * motivationalMessages.length);
        return motivationalMessages[randomIndex];
    };

    const greeting = getCurrentGreeting();
    const message = getRandomMessage();

    return (
        <Box sx={{ mb: { xs: 1, sm: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                {/* <Box
                    sx={{
                        width: { xs: 40, sm: 50, md: 60 },
                        height: { xs: 40, sm: 50, md: 60 },
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: `${waveAnimation} 2s ease-in-out infinite`,
                        '&:hover': {
                            animation: `${shakeAnimation} 0.8s ease-in-out`
                        }
                    }}
                >
                    <img
                        src="/chatbot-assets/chatbot-icon.svg"
                        alt="EchoBuddy Bot"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </Box> */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        // background: 'linear-gradient(135deg, #103680 0%, #4C41FF 100%)',
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontSize: { xs: '20px', sm: '24px', md: '28px' }
                    }}
                >
                    {greeting}, {formatName(userName)}!
                </Typography>
            </Box>

            {/* <Typography
                variant="body1"
                sx={{
                    color: '#64748B',
                    fontSize: { xs: '15px', sm: '17px' },
                    fontWeight: 500,
                    lineHeight: 1.6,
                    letterSpacing: '0.01em',
                    ml: { xs: 6, sm: 7.5, md: 9 } // Align with text above
                }}
            >
                {message}
            </Typography> */}
            <Typography
                variant="body1"
                sx={{
                    color: '#64748B',
                    fontSize: { xs: '15px', sm: '17px' },
                    fontWeight: 500,
                    lineHeight: 1.6,
                    letterSpacing: '0.01em',
                }}
            >
                {message}
            </Typography>

        </Box>
    );
};

export default WelcomeMessage;
